module.exports = __webpack_public_path__ + "img/mockup-chart-daily.c13795b7.png";